import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const devToolsRoutes: MenuInterface[] = [
    {
        code: 'GestionRemonterBaseReference',
        route: [
            {
                content: 'dev-tools/reset-database',
                focus: 'empty'
            }, 'content'
        ]
    }
];
